import Highcharts from 'highcharts';

export function getPatterns(colors) {
    const patterns = []
    colors.map((item, index) => {
        patterns.push(getPattern(index, colors))
    })
    return patterns
}

export function getPattern(index, colors) {
    return {
        pattern: Highcharts.merge(Highcharts.patterns[index], {
            color: colors[index]
        })
    };
}

export function getBackgroundPatternForAreaChart(props) {
    let array = []

    if (props.useAccessibilityStyles) {
        props.graphData.map((item, index) => {
            array.push({
                name: item.name,
                data: item.data.map((item) => item.value),
                fillColor: {
                    pattern: getPattern(index, props.colors).pattern
                }
            })
        })
    } else {
        array = props.seriesData
    }

    return array
}